var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fa-modal',{attrs:{"visible":_vm.visible,"title":"操作指引","footer":null,"width":"75%"},on:{"cancel":_vm.close}},[_c('img',{attrs:{"src":require("@/assets/guide.gif"),"alt":"","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }